export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkacv';
export const NAME = 'ZakazkaCiziVykony';
export const WITHOUT_GST_COLUMN_NAME: readonly string[] = ['PC_VC_DPH_NAD', 'PC_BEZ_DPH_NAD', 'NC_BEZ_DPH'];
export const GST_COLUMN_NAME: readonly string[] = ['PC_WITH_GST', 'PC_WITHOUT_GST'];
export const CV_NR='CV_NR';
export const EXTERNAL_OPERATION_TYPE_ID = 'EXTERNAL_OPERATION_TYPE_ID';
export const TEXT='TEXT';
export const DISCOUNT_PERCENT='DISCOUNT_PERCENT';
export const EXT_LO_QUANTITY='EXT_LO_QUANTITY';
export const EXT_LO_TABLE='ZakazkaCiziVykony';
export const UNIT_OF_MEASUREMENT='UNIT_OF_MEASUREMENT';
export const BILL_TO='BILL_TO';
export const VAT='VAT';
export const SUPPLIER_ID='SUPPLIER_ID';
export const SUPPLIER_NAME='SUPPLIER_NAME';
export const SERVICE_JOB_NAME ='SERVICE_JOB_NAME';
export const COST ='COST';
export const PC_PP_SL_PO='PC_PP_SL_PO';
export const PC_VC_DPH_NAD='PC_VC_DPH_NAD';
export const PC_BEZ_DPH_NAD='PC_BEZ_DPH_NAD';
export const PC_WITH_GST='PC_WITH_GST';
export const SPLIT_BILLING='SplitBilling';
export const EXTLABOUR='EXTLABOUR';
export const SERVICE_JOB_SPLIT_BILLING='ServiceJobSplitBilling';
export const MIN_DISCOUNT_LIMIT = 0;
export const MAX_DISCOUNT_LIMIT = 100;
export const MIN_FIELD_LEVEL = 0;
export const LINE_ITEM_STATUS='LINE_ITEM_STATUS';
export const EXT_LO_UNIT_PRICE='EXT_LO_UNIT_PRICE';
export const ROW_SAVED = 'Ex.LO Row Saved';
export const ROW_EDIT_CLICKED = 'Ex.LO Row Edit Clicked';
export const IS_PARTY_LEVEL_DISCOUNT_ENABLE = 'IS_PARTY_LEVEL_DISCOUNT_ENABLE';
export const DISCOUNT_VAL = 'DISCOUNT_VAL';

export const EXT_LABOR_COLS = {
	CV_NR,
	EXTERNAL_OPERATION_TYPE_ID,
    TEXT,
    DISCOUNT_PERCENT,
    EXT_LO_QUANTITY,
    SERVICE_JOB_NAME,
    UNIT_OF_MEASUREMENT,
	BILL_TO,
    VAT,
    COST,
    SUPPLIER_NAME,
    PC_PP_SL_PO,
    PC_WITH_GST,
    PC_BEZ_DPH_NAD,
    PC_VC_DPH_NAD,
    LINE_ITEM_STATUS,
    EXT_LO_UNIT_PRICE,
	IS_PARTY_LEVEL_DISCOUNT_ENABLE,
	DISCOUNT_VAL,
};
